export default __webpack_public_path__ + "static/media/73.86a0e5c3.png";